import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnChanges,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Input,
  DestroyRef,
  inject,
  signal,
} from "@angular/core";
//import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatSort } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute, Router, RouterLinkWithHref } from "@angular/router";
import {
  MatDialogModule,
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { MsalService } from "@azure/msal-angular";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

// Services
import { StoreUserService } from '@app/core/state/store-user.service';
import { DatabaseCacheService } from "../../../data/cache/database-cache.service";

// For Dialog view
import {
  SystemAdminDetailsComponent,
  SysAdminData,
} from "../system-admin-details/system-admin-details.component";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TableSkeletonComponent } from "../../../shared/skeleton";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { DISTRIBUTOR_LIST_I18N } from "./distributor-list.i18n";
import { ListDistributorsService } from "src/app/data/distributor/list-distributors.service";
import { DistributorDocument, DistributorDetailsComponent, DistributorDetailMode } from "../distributor-details/distributor-details.component";
import { GetParameterService } from "../../../data/record/get-parameter.service";
import { UserDataTemplateListComponent } from "../user-data-template-list/user-data-template-list.component";

@Component({
  selector: "app-distributor-list",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./distributor-list.component.html",
  styleUrls: ["./distributor-list.component.scss"],
  imports: [...SHARED_IMPORTS, TableSkeletonComponent, PageHeaderComponent],
})
export class DistributorListComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  // i18n定数（型安全・IDE補完対応）
  protected readonly i18n = DISTRIBUTOR_LIST_I18N;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("menuTrigger") menuTrigger: MatMenuTrigger;
  @ViewChild("searchInput") searchInput: ElementRef<HTMLInputElement>;

  loginUserId = "";
  filter = ""; //table filtering
  isLoading = signal(true);
  readonly searchExpanded = signal(false);

  hasSystemAdminManagement;
  hasDistributorManagement;

  distributors: DistributorDocument[] = [];
  distributorSectionGroupCountMap: Record<string, number> = {};
  userDataTemplates;

  displayedColumns = ["name", "numOfSectionGroups"];
  pageTitle = "代理店リスト";

  accountStatus: { [key: string]: string } = {
    OPEN: DISTRIBUTOR_LIST_I18N.status.active,
    CLOSE: DISTRIBUTOR_LIST_I18N.status.inactive,
  };

  //dialog with path param
  private dialogRef: MatDialogRef<any, any>;
  private routerUrl: string;

  dataSource: MatTableDataSource<DistributorDocument>;

  constructor(
    public storeUser: StoreUserService,
    private route: ActivatedRoute,
    private listDistributorsService: ListDistributorsService,
    private router: Router,
    private msalService: MsalService,
    public dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
    private common: DatabaseCacheService,
    private getParameterService: GetParameterService,
    private userDataTemplateListComponent: UserDataTemplateListComponent,

  ) {
    let user = this.msalService.instance.getActiveAccount();
    this.loginUserId = user.idTokenClaims["sub"];

    // カスタムSVG iconの呼び出し
    this.iconRegistry.addSvgIcon(
      "icon_staff", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_staff.svg",
      ), //必ずサニタイザーを利用して取得する。
    );

    this.iconRegistry.addSvgIcon(
      "icon_setting", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_setting.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-close", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-close.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-open", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-open.svg",
      ),
    );
  }

  ngOnInit() {
    this.getUserDataTemplates();

    //Admin の一覧で表示を制御する
    // this.displayedColumns = ["name", "numOfSectionGroups"];



    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.listDistributors();
      this.hasSystemAdminManagement = this.common.hasSystemAdminManagement();
      if (!this.hasSystemAdminManagement){
        this.pageTitle = "代理店情報";
      }
      this.hasDistributorManagement = this.common.hasDistributorManagement();
    });

    this.common.parametersUpdated.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((noData) => {});
  }

  ngAfterViewInit() {}

  applyFilter(event?: Event) {
    if (event) {
      this.filter = (event.target as HTMLInputElement).value;
    }
    const filterValue = this.filter.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  // M3 Expandable Search methods
  expandSearch(): void {
    this.searchExpanded.set(true);
    setTimeout(() => {
      this.searchInput?.nativeElement?.focus();
    }, 50);
  }

  collapseSearch(): void {
    if (!this.filter.trim()) {
      this.searchExpanded.set(false);
    }
  }

  onSearchBlur(): void {
    this.collapseSearch();
  }

  clearSearch(event: Event): void {
    event.stopPropagation();
    this.filter = "";
    this.applyFilter();
  }


  openDistributorDetailsDialog(res): void {

    const dialogRef = this.dialog.open(DistributorDetailsComponent, {
      width: "740px",
      disableClose: false,

      data: {
        title: this.i18n.dialog.confirmTitle,
        message: this.i18n.dialog.confirmMessage,
        distributorDocument: res,
        mode: DistributorDetailMode.disp,
        userDataTemplates: this.userDataTemplates,
      },
    });
    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (result) => {
      if (result?.needRefresh) {
        await this.common.refreshAllData();
        this.listDistributors();
      }
    });
  }

  refreshData(): void {
    this.listDistributors();
  }

  
  getUserDataTemplates() {
    this.getParameterService
      .getParameter(this.userDataTemplateListComponent.parameterName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          console.log("getUserDataTemplates", res);
          this.userDataTemplates = (res as any).parameterValue;
        },
        (error) => {
          // Error handling
        },
      );
  }

  listDistributors() {
    this.isLoading.set(true);

    this.listDistributorsService.listAdministeredDistributors().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (res) => {
        this.distributors = [];
        for (let i = 0; i < (res as any).length; i++) {
          let data = (res as any)[i];

          let distributor : DistributorDocument = {
            ...data,
            agents: []
          }

          console.log("loading... distributor", distributor);
          this.distributors.push(distributor);
        }

        let sectionGroups = this.common.getSectionGroupDocuments();
        this.distributorSectionGroupCountMap = sectionGroups.reduce((acc, sg) => {
          const distId = sg.billingInfo?.billToDistributorId;
          if (distId) {
            acc[distId] = (acc[distId] || 0) + 1;
          }
          return acc;
        }, {} as Record<string, number>);
      
        this.dataSource = new MatTableDataSource(this.distributors);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.isLoading.set(false);
      },
      (error) => {
        this.isLoading.set(false);
      },
    );
  }
}
